import { title } from 'process'

export const usePartnerships = () => {

  const { t } = useI18n()

  const partnershipItems = [
    {
      title: t('partnerships.partnerships.item1.title'),
      text: t('partnerships.partnerships.item1.text'),
      image: {
        url: '/images/partnerships/forum-odpowiedzialnego-biznesu.png',
        alternative: t('partnerships.partnerships.item1.title'),
      },
      details: [
        t('partnerships.partnerships.item1.details[0].item'),
        t('partnerships.partnerships.item1.details[1].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item3.title'),
      text: t('partnerships.partnerships.item3.text'),
      image: {
        url: '/images/partnerships/stowarzyszenie-emitentow-gieldowych.png',
        alternative: t('partnerships.partnerships.item3.title'),
      },
      details: [
        t('partnerships.partnerships.item3.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item4.title'),
      text: t('partnerships.partnerships.item4.text'),
      image: {
        url: '/images/partnerships/zwiazek-przedsiebiorcow-i-pracodawcow.png',
        alternative: t('partnerships.partnerships.item4.title'),
      },
      details: [
        t('partnerships.partnerships.item4.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item5.title'),
      text: t('partnerships.partnerships.item5.text'),
      image: {
        url: '/images/partnerships/konfederacja-lewiatan.png',
        alternative: t('partnerships.partnerships.item5.title'),
      },
      details: [
        t('partnerships.partnerships.item5.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item6.title'),
      text: t('partnerships.partnerships.item6.text'),
      image: {
        url: '/images/partnerships/polska-federacja-fintess.png',
        alternative: t('partnerships.partnerships.item6.title'),
      },
      details: [
        t('partnerships.partnerships.item6.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item7.title'),
      text: t('partnerships.partnerships.item7.text'),
      image: {
        url: '/images/partnerships/polska-rada-centrow-handlowych.png',
        alternative: t('partnerships.partnerships.item7.title'),
      },
      details: [
        t('partnerships.partnerships.item7.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item8.title'),
      text: t('partnerships.partnerships.item8.text'),
      image: {
        url: '/images/partnerships/ihrsa.png',
        alternative: t('partnerships.partnerships.item8.title'),
      },
      details: [
        t('partnerships.partnerships.item8.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item9.title'),
      text: t('partnerships.partnerships.item9.text'),
      image: {
        url: '/images/partnerships/reps-polska.png',
        alternative: t('partnerships.partnerships.item9.title'),
      },
      details: [
        t('partnerships.partnerships.item9.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item10.title'),
      text: t('partnerships.partnerships.item10.text'),
      image: {
        url: '/images/partnerships/czech-fitness-chamber.png',
        alternative: t('partnerships.partnerships.item10.title'),
      },
      details: [
        t('partnerships.partnerships.item10.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item11.title'),
      text: t('partnerships.partnerships.item11.text'),
      image: {
        url: '/images/partnerships/chamber-of-commerce-of-central-bohemia-region.png',
        alternative: t('partnerships.partnerships.item11.title'),
      },
      details: [
        t('partnerships.partnerships.item11.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item12.title'),
      text: t('partnerships.partnerships.item12.text'),
      image: {
        url: '/images/partnerships/fundacja-aktivni-cesko.png',
        alternative: t('partnerships.partnerships.item12.title'),
      },
      details: [
        t('partnerships.partnerships.item12.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item13.title'),
      text: t('partnerships.partnerships.item13.text'),
      image: {
        url: '/images/partnerships/iaa-polska.png',
        alternative: t('partnerships.partnerships.item13.title'),
      },
      details: [
        t('partnerships.partnerships.item13.details[0].item'),
      ],
    },
    {
      title: t('partnerships.partnerships.item14.title'),
      text: t('partnerships.partnerships.item14.text'),
      image: {
        url: t('partnerships.partnerships.item14.image.url'),
        alternative: t('partnerships.partnerships.item14.title'),
      },
      details: [
        t('partnerships.partnerships.item14.details[0].item'),
      ],
    },
  ]

  const ratings = {
    title: 'responsibleBusiness.ratingsTitle',
    items: [
      {
        title: 'partnerships.ratings.items.item1.title',
        text: 'partnerships.ratings.items.item1.text',
        image: {
          url: '/images/icon-rating.png',
        },
        link: {
          text: 'partnerships.ratings.items.item1.link.text',
          href: 'partnerships.ratings.items.item1.link.link',
          external: true,
        },
      },
      {
        title: 'partnerships.ratings.items.item2.title',
        text: 'partnerships.ratings.items.item2.text',
        image: {
          url: '/images/icon-rating.png',
        },
        link: {
          text: 'partnerships.ratings.items.item2.link.text',
          href: 'partnerships.ratings.items.item2.link.link',
          external: true,
        },
      },
    ],
  }

  const awards = [
    {
      title: t('partnerships.awards.items.item6.title'),
      description: t('partnerships.awards.items.item6.text'),
    },
    {
      title: t('partnerships.awards.items.item7.title'),
      description: t('partnerships.awards.items.item7.text'),
    },
    {
      title: t('partnerships.awards.items.item1.title'),
      description: t('partnerships.awards.items.item1.text'),
    },
    {
      title: t('partnerships.awards.items.item2.title'),
      description: t('partnerships.awards.items.item2.text'),
      descriptionLong: t('partnerships.awards.items.item2.textLong'),
    },
    {
      title: t('partnerships.awards.items.item3.title'),
      description: t('partnerships.awards.items.item3.text'),
    },
    {
      title: t('partnerships.awards.items.item4.title'),
      description: t('partnerships.awards.items.item4.text'),
    },
    {
      title: t('partnerships.awards.items.item5.title'),
      description: t('partnerships.awards.items.item5.text'),
    },
  ]

  return {
    partnershipItems,
    ratings,
    awards,
  }
}
